module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/intro.htm#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("1. Know the Enemy: Understanding Eating Disorders")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c01-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#c01-s1"
    }
  }, [_vm._v("What Are Eating Disorders?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c01-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#c01-s2"
    }
  }, [_vm._v("Anorexia Nervosa")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c01-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#c01-s3"
    }
  }, [_vm._v("Bulimia Nervosa")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c01-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#c01-s4"
    }
  }, [_vm._v("Binge Eating Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c01-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#c01-s5"
    }
  }, [_vm._v("Body Dysmorphic Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c01-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#c01-s6"
    }
  }, [_vm._v("Eating Disorders Not Otherwise Specified")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c01-s7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm#c01-s7"
    }
  }, [_vm._v("Coexisting Disorders")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("2. Myths and Misconceptions about Eating Disorders")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c02-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#c02-s1"
    }
  }, [_vm._v("It Only Affects Rich, White Girls")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c02-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#c02-s2"
    }
  }, [_vm._v("Manorexia")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c02-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#c02-s3"
    }
  }, [_vm._v("Adolescents Only Need Apply")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c02-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#c02-s4"
    }
  }, [_vm._v("Whites Only")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c02-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#c02-s5"
    }
  }, [_vm._v("Religion as Protection")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c02-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#c02-s6"
    }
  }, [_vm._v("But They Don’t Look Thin")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c02-s7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#c02-s7"
    }
  }, [_vm._v("It’s about Control")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c02-s8"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#c02-s8"
    }
  }, [_vm._v("It’s Just Vanity")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c02-s9"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm#c02-s9"
    }
  }, [_vm._v("Eating Disorders Aren’t That Dangerous")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c03"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("3. Identifying Signs and Symptoms in Children "), _c('br'), _vm._v("up to Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c03-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#c03-s1"
    }
  }, [_vm._v("Children and Disordered Eating")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c03-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#c03-s2"
    }
  }, [_vm._v("How Do I Know?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c03-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#c03-s3"
    }
  }, [_vm._v("Physical Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c03-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#c03-s4"
    }
  }, [_vm._v("Emotional Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c03-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#c03-s5"
    }
  }, [_vm._v("Special Considerations for Treatment")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c03-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm#c03-s6"
    }
  }, [_vm._v("Prevention")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c04"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("4. Identifying Signs and Symptoms in Adolescents "), _c('br'), _vm._v("and Young Adults")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s1"
    }
  }, [_vm._v("How to Tell If Your Child Has an Eating Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s2"
    }
  }, [_vm._v("Signs and Symptoms of an Eating Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s3"
    }
  }, [_vm._v("Obsessive Behavior")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s4"
    }
  }, [_vm._v("Physical Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s5"
    }
  }, [_vm._v("Weight")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s6"
    }
  }, [_vm._v("Emotional Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s7"
    }
  }, [_vm._v("It’s a Thinking Problem")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s8"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s8"
    }
  }, [_vm._v("Unhealthy Coping Strategies")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s9"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s9"
    }
  }, [_vm._v("The Risk of Athletics")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s10"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s10"
    }
  }, [_vm._v("College Concerns")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c04-s11"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm#c04-s11"
    }
  }, [_vm._v("Do Your Research")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c05"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("5. Causes of an Eating Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c05-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm#c05-s1"
    }
  }, [_vm._v("Looking for an Answer")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c05-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm#c05-s2"
    }
  }, [_vm._v("The Blame Game")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c05-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm#c05-s3"
    }
  }, [_vm._v("Biology Rules")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c05-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm#c05-s4"
    }
  }, [_vm._v("Messages Matter")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c05-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm#c05-s5"
    }
  }, [_vm._v("Media Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c05-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm#c05-s6"
    }
  }, [_vm._v("What’s in the Way of Recovery?")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c06"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("6. Facing Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c06-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#c06-s1"
    }
  }, [_vm._v("Coming to the Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c06-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#c06-s2"
    }
  }, [_vm._v("Next Step: Talk to Your Child")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c06-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#c06-s3"
    }
  }, [_vm._v("In Search of a Diagnosis")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c06-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#c06-s4"
    }
  }, [_vm._v("Understanding Lab Tests")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c06-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#c06-s5"
    }
  }, [_vm._v("A Psychiatric Evaluation")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c06-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#c06-s6"
    }
  }, [_vm._v("The Diagnostic Criteria")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c06-s7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm#c06-s7"
    }
  }, [_vm._v("Does She or Doesn’t She?")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c07"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("7. Steps Toward Treatment")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c07-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm#c07-s1"
    }
  }, [_vm._v("A New Attitude")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c07-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm#c07-s2"
    }
  }, [_vm._v("Early Intervention")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c07-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm#c07-s3"
    }
  }, [_vm._v("Begin the Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c07-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm#c07-s4"
    }
  }, [_vm._v("Choosing a Treatment Approach")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c07-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm#c07-s5"
    }
  }, [_vm._v("Finding a Dietitian")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c08"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("8. Finding Your Voice")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c08-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm#c08-s1"
    }
  }, [_vm._v("Become an Advocate for Your Child")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c08-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm#c08-s2"
    }
  }, [_vm._v("Do Your Homework")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c08-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm#c08-s3"
    }
  }, [_vm._v("Learn to Communicate with Providers")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c08-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm#c08-s4"
    }
  }, [_vm._v("Take Care of the Details")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c08-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm#c08-s5"
    }
  }, [_vm._v("Connect with Others")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c08-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm#c08-s6"
    }
  }, [_vm._v("Develop a Thick Skin")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c09"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("9. Paying for Treatment")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c09-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm#c09-s1"
    }
  }, [_vm._v("The Costs of Treatment")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c09-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm#c09-s2"
    }
  }, [_vm._v("What If You Don’t Have Health Insurance?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c09-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm#c09-s3"
    }
  }, [_vm._v("How to Tell What’s Covered")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c09-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm#c09-s4"
    }
  }, [_vm._v("When Your Claim Is Denied")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c09-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm#c09-s5"
    }
  }, [_vm._v("Alternate Avenues")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c10"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("10. Understanding Treatment Options")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c10-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm#c10-s1"
    }
  }, [_vm._v("What Treatment Means")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c10-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm#c10-s2"
    }
  }, [_vm._v("Setting Treatment Goals")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c10-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm#c10-s3"
    }
  }, [_vm._v("Inpatient Care")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c10-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm#c10-s4"
    }
  }, [_vm._v("Nutritional Goals")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c10-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm#c10-s5"
    }
  }, [_vm._v("When Hospitalization Is Necessary")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c10-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm#c10-s6"
    }
  }, [_vm._v("Hospital Admission")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c10-s7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm#c10-s7"
    }
  }, [_vm._v("Nonmedical Residential Care")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c10-s8"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm#c10-s8"
    }
  }, [_vm._v("Outpatient Care Options")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c11"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("11. Understanding Medication Options")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c11-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm#c11-s1"
    }
  }, [_vm._v("Why Medication?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c11-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm#c11-s2"
    }
  }, [_vm._v("Getting Started on Medication")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c11-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm#c11-s3"
    }
  }, [_vm._v("Antidepressants")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c11-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm#c11-s4"
    }
  }, [_vm._v("Antianxiety Medications")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c11-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm#c11-s5"
    }
  }, [_vm._v("Fluoxetine")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c11-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm#c11-s6"
    }
  }, [_vm._v("Less Commonly Prescribed Medications")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c11-s7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm#c11-s7"
    }
  }, [_vm._v("When You Get a New Prescription")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c11-s8"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm#c11-s8"
    }
  }, [_vm._v("Making Medication Decisions")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c11-s9"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm#c11-s9"
    }
  }, [_vm._v("Medication Noncompliance")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c12"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_vm._v("12. Understanding Counseling")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c12-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm#c12-s1"
    }
  }, [_vm._v("Why Counseling Is Necessary")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c12-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm#c12-s2"
    }
  }, [_vm._v("Where to Begin")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c12-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm#c12-s3"
    }
  }, [_vm._v("Cognitive Behavioral Therapy")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c12-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm#c12-s4"
    }
  }, [_vm._v("Family Involvement")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c12-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm#c12-s5"
    }
  }, [_vm._v("The Perfect Fit")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c12-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm#c12-s6"
    }
  }, [_vm._v("What Matters Most")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c13"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_vm._v("13. Complementary Therapies")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s1"
    }
  }, [_vm._v("What Is Complementary Care?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s2"
    }
  }, [_vm._v("Animal-Assisted Therapy")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s3"
    }
  }, [_vm._v("Art Therapy")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s4"
    }
  }, [_vm._v("Biofeedback")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s5"
    }
  }, [_vm._v("Energy Healing")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s6"
    }
  }, [_vm._v("Herbal Medication")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s7"
    }
  }, [_vm._v("Hypnotherapy")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s8"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s8"
    }
  }, [_vm._v("Meditation")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s9"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s9"
    }
  }, [_vm._v("Music Therapy")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s10"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s10"
    }
  }, [_vm._v("Spiritual Support")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s11"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s11"
    }
  }, [_vm._v("Twelve-Step Programs")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c13-s12"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#c13-s12"
    }
  }, [_vm._v("Yoga and Other Movement Activities")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c14"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("14. Good Nutrition Is Medicine")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c14-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#c14-s1"
    }
  }, [_vm._v("Setting Priorities")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c14-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#c14-s2"
    }
  }, [_vm._v("Why You Must Take Control")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c14-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#c14-s3"
    }
  }, [_vm._v("Setting Appropriate Goals")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c14-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#c14-s4"
    }
  }, [_vm._v("Starting from Scratch")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c14-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#c14-s5"
    }
  }, [_vm._v("How to Take Charge")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c14-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#c14-s6"
    }
  }, [_vm._v("What Does My Child Need?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c14-s7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#c14-s7"
    }
  }, [_vm._v("What Do I Feed My Child?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c14-s8"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm#c14-s8"
    }
  }, [_vm._v("This Is Miserable!")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c15"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_vm._v("15. When Disagreements Occur")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c15-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm#c15-s1"
    }
  }, [_vm._v("The Nature of Disagreements")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c15-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm#c15-s2"
    }
  }, [_vm._v("When Professionals Disagree")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c15-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm#c15-s3"
    }
  }, [_vm._v("When You Disagree with the Hospital")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c15-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm#c15-s4"
    }
  }, [_vm._v("When Your Child Refuses Treatment")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c15-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm#c15-s5"
    }
  }, [_vm._v("Resistance in Adult Children")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c15-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm#c15-s6"
    }
  }, [_vm._v("Coping with Resistance")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c16"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm"
    }
  }, [_vm._v("16. Help for the Parents")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c16-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm#c16-s1"
    }
  }, [_vm._v("Self-Care")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c16-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm#c16-s2"
    }
  }, [_vm._v("Share the Pain")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c16-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm#c16-s3"
    }
  }, [_vm._v("Protect the Parents’ Relationship")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c16-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm#c16-s4"
    }
  }, [_vm._v("Get Real about Your Feelings")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c16-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm#c16-s5"
    }
  }, [_vm._v("It’s about Me")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c16-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm#c16-s6"
    }
  }, [_vm._v("When a Parent Has an Eating Disorder")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c16-s7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm#c16-s7"
    }
  }, [_vm._v("A Parent’s Food Issues")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c17"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17.htm"
    }
  }, [_vm._v("17. The Rest of the Family")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c17-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17.htm#c17-s1"
    }
  }, [_vm._v("The Rest of the Family")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c17-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17.htm#c17-s2"
    }
  }, [_vm._v("When Partners Disagree")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c17-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17.htm#c17-s3"
    }
  }, [_vm._v("Helping Siblings")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c17-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17.htm#c17-s4"
    }
  }, [_vm._v("When the Dinner Table Is a Battlefield")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "c18"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm"
    }
  }, [_vm._v("18. Chasing Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c18-s1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm#c18-s1"
    }
  }, [_vm._v("What Recovery Means")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c18-s2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm#c18-s2"
    }
  }, [_vm._v("The Bumpy Road to Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c18-s3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm#c18-s3"
    }
  }, [_vm._v("Recovery Peers")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c18-s4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm#c18-s4"
    }
  }, [_vm._v("Prepared = Protected")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c18-s5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm#c18-s5"
    }
  }, [_vm._v("Understanding Triggers")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "c18-s6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm#c18-s6"
    }
  }, [_vm._v("Imperfect Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "extract",
    attrs: {
      "id": "appa"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/appa.htm"
    }
  }, [_vm._v("Appendix A. Recommended Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "appb"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/appb.htm"
    }
  }, [_vm._v("Appendix B. Organizational Resource List")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "appc"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/appc.htm"
    }
  }, [_vm._v("Appendix C. Web Resources")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "appd"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/appd.htm"
    }
  }, [_vm._v("Appendix D. Eating Disorder Questionnaire")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "index"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "cop"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ef1ee3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 81
// module chunks = 0